export default __webpack_public_path__ + "static/images/fd2e54a3b9a6836b26cb7e4f5d3def3a.png";